const setCurrentSubjectTopicReducer = (state = {}, action = {}) => {
    if (action.type === 'CURRENT_SUBJECT_TOPIC') {
        return action.payload;
    }
    return state;
};

export default setCurrentSubjectTopicReducer;
